<template>
  <div class=" container w-75 mx-auto">
    <div class="row align-items-center p-3">
      <div class="col-sm-4">
        <label for="price_id" class="form-label">Familia de materia prima asociada:</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="rawMat_id" v-model="rawMaterialId" @change="setMaterialByRawMatId(rawMaterialId)">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="rawMaterial in rawMaterialList" :key="rawMaterial._id" v-bind:value="rawMaterial.id">
            {{ rawMaterial.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="specification" class="form-label">Especificación/Norma:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select" id="existSpecification" @change="listSpecifications" v-model="existSpecification">
          <option selected>Opciones disponibles...</option>
          <option v-for="specification in sheetSpecification" :key="specification" v-bind:value="specification">
            {{ specification }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control" v-model="specification" id="specification" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="presentation" class="form-label">Presentación:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select" @change="listPresentations" id="existPresentation" v-model="existPresentation">
          <option selected>Opciones disponibles...</option>
          <option v-for="presentation in sheetPresentation" :key="presentation" v-bind:value="presentation">
            {{ presentation }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control" id="presentation" v-model="presentation" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="scale" class="form-label">Escala de espesor:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select" @change="listScales" id="existScale" v-model="existScale">
          <option selected>Opciones disponibles...</option>
          <option v-for="scale in sheetScale" :key="scale" v-bind:value="scale">
            {{ scale }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control" id="scale" v-model="scale" />
      </div>
    </div>
    <div class="row align-items-center p-3">
      <div class="col-sm-4">
        <label for="price_id" class="form-label">Precio asociado :</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="price_id" v-model="priceId">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="price in pricesList" :key="price._id" v-bind:value="price.id">
            {{ price.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="p-3 border-bottom">
      <button class="btn btn-light" @click.prevent="saveSheet" :disabled="isButtonDisabled">
        Cargar lámina
      </button>
    </div>
    <div class="container w-75 mx-auto">
      <div class="row align-items-center p-3">
        <div class="col-sm-8 col-12">
          <div class="form-text">
            Para añadir los datos de la lámina
            <i>(Espesores disponibles y el valor en pesos de cada servicio según
              el espesor.)</i>, descargue la siguiente plantilla de excel y haga las
            modificaciones necesarias sobre esta.
          </div>
        </div>
        <div class="col-sm-4 col-12">
          <button class="btn btn-secondary" @click.prevent="downloadTemplate">
            Descargar plantilla
          </button>
        </div>
      </div>
      <div class="row align-items-center mt-3 mb-3">
        <div class="col-sm-8 col-12">
          <ul>
            <li>{{ condition1 }}</li>
            <li>{{ condition2 }}</li>
            <li>{{ condition3 }}</li>
            <li>{{ condition4 }}</li>
            <li>{{ condition5 }}</li>
            <li>{{ condition6 }}</li>
            <li>{{ condition7 }}</li>
            <li>{{ condition8 }}</li>
          </ul>
        </div>
        <div class="col-sm-4 col-12">
          <input type="file" ref="file" @change="previewFile()" class="form-control" />
          <hr />
        </div>
      </div>
      <div class="mx-auto mb-4">
        <button class="btn btn-danger" @click.prevent="saveSheetTypes">
          Guardar datos para la lámina
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      serverUrl: RUTA_SERVIDOR,
      priceId: 0,
      sheetId: 0,
      rawMaterialId: 0,
      priceDefault: "lam",
      pricesList: [],
      sheetsList: [],
      rawMaterialList: [],
      isButtonDisabled: false,
      //Campos
      existMaterial: "",
      material: "",
      existSpecification: "",
      specification: "",
      existPresentation: "",
      presentation: "",
      existScale: "",
      scale: "",
      fileSheetTypes: undefined,
      currentFile: undefined,
      //Listas sobre láminas
      sheetSpecification: [],
      sheetPresentation: [],
      sheetScale: [],
      //Texto en la vista
      condition1: "El archivo debe contener los encabezados en la primera fila",
      condition2:
        "Puede agregar todas los registros que considere necesarios (filas).",
      condition3: "No debe alterar la cantidad de campos (columnas).",
      condition4: "El separador de decimales debe ser un punto (.).",
      condition5: "No debe tener separador de miles o millares.",
      condition6:
        "Asegurese de que los campos que tienen caracter como +, -, * o / son tratados como TEXTO en excel. De lo contrario pueden ser tomados como una operacion aritmética.",
      condition7:
        "No utilice ninguno de los siguientes caracteres $ % & | ° =  # ¿ ? ¡ ! '\"';",
      condition8:
        "Guarde el archivo en el mismo formato en que lo descargo (CSV delimitado por comas).",
    };
  },
  methods: {
    setMaterialByRawMatId(id) {
      // console.log(id);
      if (id === 1 || id === 2) {
        this.material = "ACERO AL CARBONO";
      } else if (id === 3) {
        this.material = "ACERO INOXIDABLE";
      } else if (id === 4) {
        this.material = "ALUMINIO";
      } else {
        this.material = "";
      }
    },
    listSpecifications() {
      this.existSpecification.trim() === "Opciones disponibles..."
        ? (this.specification = "")
        : (this.specification = this.existSpecification);
    },
    listPresentations() {
      this.existPresentation.trim() === "Opciones disponibles..."
        ? (this.presentation = "")
        : (this.presentation = this.existPresentation);
    },
    listScales() {
      this.existScale.trim() === "Opciones disponibles..."
        ? (this.scale = "")
        : (this.scale = this.existScale);
    },
    downloadTemplate() {
      // URL del archivo en el backend
      const urlArchivo = this.serverUrl + 'templates/LaminaPlatilla.csv';

      // Crea un enlace invisible
      const enlace = document.createElement('a');
      enlace.href = urlArchivo;
      enlace.style.display = 'none';

      // Asigna un nombre al archivo que se descargará (puede ser personalizado)
      enlace.download = 'nombre-del-archivo.pdf';

      // Agrega el enlace al DOM
      document.body.appendChild(enlace);

      // Simula un clic en el enlace para iniciar la descarga
      enlace.click();

      // Elimina el enlace después de la descarga
      document.body.removeChild(enlace);
    },
    async saveSheet() {
      if (
        this.material == "" ||
        this.presentation == "" ||
        this.specification == "" ||
        this.scale === "" ||
        this.priceId == 0 ||
        this.rawMaterialId == 0
      ) {
        alert(
          "Los campos están vacios, debe diligenciarlos para cargar la lámina de forma exitosa."
        );
      } else {
        // console.log(this.sheetsList);
        let formData = new FormData();
        formData.append("material", this.material);
        formData.append("presentation", this.presentation);
        formData.append("specification", this.specification);
        formData.append("scale", this.scale);
        formData.append("price_id", this.priceId);
        formData.append("raw_material_family_id", this.rawMaterialId);
        // formData.forEach(element => {
        //   console.log(element)
        // });
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/sheet/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          // console.log(res.data);

          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            this.sheetId = res.data[0].id;
            this.isButtonDisabled = true;
            alert("Lámina " + this.presentation + " " + this.specification + " en " + this.scale + " cargada con exito!");
            // console.log(this.sheetId);
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    async saveSheetTypes() {
      if (this.sheetId != 0) {
        // console.log(this.sheetId);
        let formData = new FormData();
        // formData.append("sheet_id", 1);
        formData.append("sheet_id", this.sheetId);
        formData.append("csvFile", this.currentFile);
        // formData.forEach(element => {
        //   console.log(element)
        // });
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/sheet/type/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Clasificación por: " + this.scale + " para lámina " + this.presentation + " " + this.specification + " agregados!");
            this.cleanFields();
            this.$router.push("/Admin/SheetCatalogue");
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      } else {
        alert(
          "No ha cargado ninguna lámina guía todavia, complete la información previa antes de subir el archivo .csv."
        );
      }
    },
    previewFile(event) {
      this.fileSheetTypes = this.$refs.file.files;
      // console.log(this.fileSheetTypes);
      this.currentFile = this.fileSheetTypes.item(0);
      // console.log(this.currentFile);
    },
    cleanData() {
      // console.log(this.sheetsList);
      // let materials = new Set(this.sheetsList.map((item) => item.material));
      // // console.log(materials);
      // materials.forEach((element) => {
      //   this.sheetMaterial.push(element);
      // });
      let specifications = new Set(
        this.sheetsList.map((item) => item.specification)
      );
      // console.log(specifications);
      specifications.forEach((element) => {
        this.sheetSpecification.push(element);
      });
      let presentations = new Set(
        this.sheetsList.map((item) => item.presentation)
      );
      // console.log(presentations);
      presentations.forEach((element) => {
        this.sheetPresentation.push(element);
      });
      let scales = new Set(this.sheetsList.map((item) => item.scale));
      // console.log(scales);
      scales.forEach((element) => {
        this.sheetScale.push(element);
      });

      // console.log(this.sheetMaterial);
      // console.log(this.sheetSpecification);
      // console.log(this.sheetPresentation);
      // console.log(this.sheetScale);
    },
    cleanFields() {
      this.existMaterial = "";
      this.material = "";
      this.existSpecification = "";
      this.specification = "";
      this.existPresentation = "";
      this.presentation = "";
      this.existScale = "";
      this.scale = "";
      this.rawMaterialId = 0;
      this.priceId = 0;
      this.isButtonDisabled = false;
      this.sheetId = 0;
    },
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/price/list", {
        params: {
          price_type: this.priceDefault,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.pricesList = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
    axios
      .get(RUTA_SERVIDOR + "api/sheet/list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => ((this.sheetsList = res.data), this.cleanData()))
      .catch((err) => console.log(`There has been an error ${err}`));

    axios
      .get(RUTA_SERVIDOR + "api/rawMaterial/list", {
        params: {
          rawMaterial_type: this.priceDefault,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.rawMaterialList = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>
<style scoped></style>